import React, { useEffect, useState } from "react";
import { Modal, Spin, Button, Popover} from "antd";
import { useDispatch } from "react-redux";
import { setThreat, setNewThreat } from "../../slices/riskSlice";

const TableCellThreatNew = ({item, addNew}) => {

    const dispatch = useDispatch();
    const [threat2, setStateThreat2] = useState("");
    const [checkedItem, setCheckedItem] = useState(null);
    const [checkedIdthreat, setCheckedIdthreat] = useState("");
	const [addThreat2, setAddThreat2] = useState(false);
    const [threat, setStateThreat] = useState([]);
    const [threatArray, setStateThreatArray] = useState([]);
    const [threatArrayUl, setStateThreatArrayUl] = useState([]);

    return (
        <>
            {threatArray.map((element, index) => 
                <>
                    {element
                        &&
                        <div className={`hovers ${index}`}>
                            <ul style={{padding: '0', margin: '0'}}>
                                {
                                    // console.log(threatArrayUl)
                                    threatArrayUl.map((item, indx) =>
                                        (indx == index) && item.map((i, ind) =>
                                        i &&
                                        <li class="autofilss">
                                            <input type="text" className="autofilssInput" onChange={(e) => dispatch(setNewThreat([index.toString(), ind, e.target.value ]))}></input>
                                        </li>
                                    ))
                                }
                                <div className="autofilss">
                                    <button onClick={(e) => {e.preventDefault(); setStateThreatArrayUl(threatArrayUl.map((item, ind) => (ind == index) ? item = [...item, true] : item));}}>+ Add</button>
                                </div>  
                            </ul>
                        </div>   
                    }    
                </>
            )}
            <div className="autofilss">
                <button onClick={(e) => {e.preventDefault(); setStateThreatArray([...threatArray, true]); setStateThreatArrayUl([...threatArrayUl, [true]])}}>+ Add</button>
            </div>  
        </>
    )
};

export default TableCellThreatNew;